import Dependencies from "./Dependencies.js";
import DeviceTypeId from "./DeviceTypeId.js";
import DeviceType from "./DeviceType.js";
import Id from "./Id.js";
import IsArchived from "./IsArchived.js";
import Metadata from "./Metadata.js";
import ProjectId from "./ProjectId.js";
import SemanticVersion from "./SemanticVersion.js";
import Type from "./Type.js";
import Version from "./Version.js";
import Name from "./Name.js";
export default {
  install(molten) {
    molten.addPlugin('Attribute', Dependencies);
    molten.addPlugin('Attribute', DeviceTypeId);
    molten.addPlugin('Attribute', DeviceType);
    molten.addPlugin('Attribute', Id);
    molten.addPlugin('Attribute', IsArchived);
    molten.addPlugin('Attribute', Metadata);
    molten.addPlugin('Attribute', ProjectId);
    molten.addPlugin('Attribute', SemanticVersion);
    molten.addPlugin('Attribute', Type);
    molten.addPlugin('Attribute', Version);
    molten.addPlugin('Attribute', Name);
  }
};